import { setupInterceptors } from '@wajeez-web/core/api';
import { createStore } from '@wajeez-web/stores/base';
import { injectAuthReducers } from '@wajeez-web/stores/auth';
import { injectCommonReducers } from '@wajeez-web/stores/common';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { i18n } from '@wajeez-web/core/utils';
import { injectProductReducers } from '@wajeez-web/stores/product';
import { injectBusinessReducers } from '@wajeez-web/stores/business-group';
import { injectCustomerReducers } from '@wajeez-web/stores/customers';
import { injectAppwatchReducers } from '@wajeez-web/stores/appwatch';
import { injectRolesReducers } from '@wajeez-web/stores/roles';
import { injectContentReducers } from '@wajeez-web/stores/content';
import 'antd/dist/reset.css';

import App from './app/app';

setupInterceptors();

const store = createStore([
  injectCommonReducers,
  injectAuthReducers,
  injectProductReducers,
  injectBusinessReducers,
  injectContentReducers,
  injectCustomerReducers,
  injectRolesReducers,
  injectAppwatchReducers,
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        {/* <BrowserRouter> */}
        <App />
        {/* </BrowserRouter> */}
      </I18nextProvider>
    </StrictMode>
  </Provider>
);
